import { mapState, mapActions } from 'vuex';
import paymentInvoiceStatusResponse from '../../tests/fixtures/paymentInvoice';

// If we got in query payment invoice ID, then this controller hanldle status and redirect to a correct page \ flow
export default {
  computed: {
    ...mapState['paymentInvoiceData'],
  },

  methods: {
    ...mapActions(['getPaymentInvoiceById', 'ADD_MESSAGE']),

    async getPaymentInvoiceData(id) {
      try {
        // await this.getPaymentInvoiceById(id);

        // eslint-disable-next-line no-console
        this.handleInvoiceStatus(paymentInvoiceStatusResponse);
      } catch (e) {
        this.ADD_MESSAGE({
          text: 'VALIDATION ERROR',
          type: 'error',
        });
        return {
          redirect: {
            name: 'ErrorPage',
            query: { code: 'error' },
          },
        };
      }

      return {
        redirect: {
          name: 'PaymentStatus',
          query: id,
        },
      };
    },

    handleInvoiceStatus(paymentIncoiceData) {
      // console.log('Payment invoice data', paymentIncoiceData);
      const {
        status: paymentInvoiceStatus,
        service,
        process_pending,
      } = paymentIncoiceData.data;
      console.log('Payment invoice status', paymentIncoiceData);
    },

    redirect(name, query) {
      this.$router.push({
        name,
        query,
      });
    },
  },
};
